import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Paper,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";

import FeaturesSubmenu from "./app/FeaturesSubmenu";
import { features } from "./app/FeaturesSubmenu";

const Header = ({ contactFormRef }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const gradientBackground = document.querySelector(".gradient-background");
      if (gradientBackground) {
        const scrollPosition = window.scrollY;
        const gradientHeight = 50;
        setIsScrolled(scrollPosition > gradientHeight);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToContact = () => {
    contactFormRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleSubMenuOpen = (index) => {
    if (submenuTimeout) {
      clearTimeout(submenuTimeout);
    }
    setOpenSubMenuIndex(index);
  };

  const handleSubMenuClose = () => {
    submenuTimeout = setTimeout(() => {
      setOpenSubMenuIndex(null);
    }, 200);
  };

  const menuItems = [
    // {
    //   label: 'Logga in',
    //   path: '/app/logga-in',
    // },

    // {
    //   label: 'För elever',
    //   path: '/ai-verktyg-elever',
    // },
    //  { label: "Priser", path: "/priser" },

    // { label: "Lärare", path: "/larare", hasSubmenu: false },
    // { label: "Elever", path: "/elever", hasSubmenu: false },
    { label: "Funktioner", path: "#", hasSubmenu: true },

    // { label: "Boka en demo", action: scrollToContact }, // Changed to use action instead of path

    { label: "Logga in", path: "/app/logga-in?ref=startpage" },
    { label: "Skapa konto", path: "/app/skapa-konto?ref=startpage" },
  ];

  const renderMenuItem = (item, index) => {
    if (item.action) {
      return (
        <Button
          onClick={item.action}
          sx={{
            textTransform: "none",
            color: "white",
            fontWeight: "600",
            cursor: "pointer !important",
            "&:hover": { background: "#ffffff12" },
            display: "flex",
            alignItems: "center",
            px: 2,
            py: 1,
            fontSize: "1.1rem",

            "& a": { cursor: "pointer" },
          }}
        >
          {item.label}
        </Button>
      );
    }

    if (item.hasSubmenu) {
      return (
        <Box
          onMouseEnter={() => setOpenMenu(true)}
          onMouseLeave={() => setOpenMenu(false)}
          sx={{
            position: "relative",
            display: "inline-block",
          }}
        >
          <Button
            sx={{
              textTransform: "none",
              color: "white",
              fontWeight: "600",
              "&:hover": { background: "#ffffff12" },
              display: "flex",
              alignItems: "center",
              px: 2,
              py: 1,
              fontSize: "1.1rem",
            }}
          >
            {item.label}
            <ExpandMoreIcon sx={{ ml: 0.5, fontSize: "1.25rem" }} />
          </Button>
          {openMenu && (
            <FeaturesSubmenu theme={theme} onClose={() => setOpenMenu(false)} />
          )}
        </Box>
      );
    }

    return (
      <Button
        component={Link}
        to={item.path}
        sx={{
          textTransform: "none",
          cursor: "pointer !important",
          color: "white",
          "& a": { cursor: "pointer" },
          fontWeight: "600",
          "&:hover": { background: "#ffffff12" },
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1,
          fontSize: "1.1rem",
          "& a, & button": { cursor: "pointer !important" },
        }}
      >
        {item.label}
      </Button>
    );
  };

  return (
    <AppBar
      elevation={isScrolled ? 4 : 0}
      sx={{
        backdropFilter: isScrolled ? "blur(6px)" : "none",
        background: isScrolled
          ? "linear-gradient(135deg, rgba(32, 6, 96, 0.8) 0%, rgba(61, 19, 104, 0.8) 100%)"
          : "transparent",
        transition: "all 0.3s ease-in-out",
        pl: { xs: 0, md: 4 },
        boxShadow: "none",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link
              to="/"
              style={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src="/img/AI.png"
                alt="Studera.ai"
                sx={{
                  height: { xs: 30, md: 35 },
                  marginRight: { xs: 1, md: 2 },
                }}
              />
              <Typography
                variant="h6"
                component="div"
                sx={{ fontWeight: "600", color: "white", fontSize: "1.35rem" }}
              >
                Studera.ai
              </Typography>
            </Link>
          </Box>
          {isMobile ? (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              sx={{ color: "white" }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {menuItems.map((item, index) => (
                <Box key={item.label}>{renderMenuItem(item, index)}</Box>
              ))}
            </Box>
          )}
        </Box>
      </Container>
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
      >
        <Box sx={{ width: 250, pt: 2 }} role="presentation">
          <IconButton sx={{ ml: 1 }} onClick={handleDrawerToggle}>
            <CloseIcon />
          </IconButton>
          <List>
            {menuItems.map((item, index) => (
              <Box key={item.label}>
                <ListItem
                  button
                  onClick={() => {
                    if (item.action) {
                      item.action();
                      handleDrawerToggle();
                    } else if (item.hasSubmenu) {
                      setMobileSubmenuOpen(!mobileSubmenuOpen);
                    }
                  }}
                  component={item.path && item.path !== "#" ? Link : "div"}
                  to={item.path && item.path !== "#" ? item.path : undefined}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <ListItemText primary={item.label} />
                  {item.hasSubmenu && <ExpandMoreIcon />}
                </ListItem>

                {/* Visa FeaturesSubmenu i drawer när mobileSubmenuOpen är true */}
                {item.hasSubmenu && mobileSubmenuOpen && (
                  <Box sx={{ pl: 2 }}>
                    {features.map((feature) => (
                      <ListItem
                        key={feature.path}
                        button
                        component={Link}
                        to={feature.path}
                        onClick={handleDrawerToggle}
                        sx={{ pl: 0 }}
                      >
                        <feature.icon
                          sx={{
                            mr: 1,
                            fontSize: "20px",
                            color: "text.secondary",
                            fontWeight: "500",
                          }}
                        />
                        <ListItemText
                          primary={feature.title}
                          primaryTypographyProps={{
                            fontWeight: 500,
                          }}
                        />
                      </ListItem>
                    ))}
                  </Box>
                )}
              </Box>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Header;
